import { getDataLabProjectUrl } from '@/dataLab/dataLab.utilities';
import { SeeqNames } from '@seeqdev/constants';
import { Icon } from '@seeqdev/qomponents';
import type { ICellRendererParams } from 'ag-grid-community';

export interface UseCaseNameCellProps {
  name: string;
  worksheetId?: string;
  workbookId?: string;
  type?: string;
}

/**
 * This cell-renderer renders a little "bubble" icon next to the use case name to indicate there is more to see and
 * encourage users to click on the cell to see more details.
 * It also includes the workbench icon that links to the associated worksheet in view mode.
 */
export const UseCaseNameCellRenderer = (props: ICellRendererParams<any, UseCaseNameCellProps>) => {
  if (!props?.value) return null;
  const { value } = props;
  if (!value) return null;

  const handleClick = () => {
    if (value.type === SeeqNames.Types.Project && value.workbookId) {
      window.open(getDataLabProjectUrl(value.workbookId), '_blank');
    } else if (value.worksheetId) {
      window.open(`/view/${value.worksheetId}`, '_blank');
    }
  };
  const type = value.type;

  const icon =
    type === SeeqNames.Types.Project
      ? 'fc-seeq-datalab'
      : type === SeeqNames.Types.Vantage
        ? 'fc-vantage'
        : type === SeeqNames.Types.Analysis
          ? 'fc-analysis'
          : 'fc-report';
  return value.name ? (
    <div className="flexColumnContainer tw:items-center">
      <div className="flexFill">
        <Icon testId="typeIcon" icon={icon} onClick={handleClick} extraClassNames="workbookIcon workbenchDisplay mr5" />
        {value.name}
      </div>
      <Icon icon="fa-comment-dots" extraClassNames="ml5 detailsBubble" />
    </div>
  ) : null;
};
